import React from "react";
import Drawer from "@material-ui/core/Drawer";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";
import { FONT_OPTIONS, FONT_SIZES } from "./constants";

const useStyles = makeStyles((theme) => ({
  drawerContent: {
    width: 300,
    padding: theme.spacing(2),
  },
  section: {
    marginTop: theme.spacing(2),
  },
}));

const PAPER_SIZES = [
  { value: "A4", label: "A4 (21 × 29,7 cm)" },
  { value: "Letter", label: "Carta (21,6 × 27,9 cm)" },
];

const PageConfigPanel = ({ open, onClose, pageConfig, onChange }) => {
  const classes = useStyles();

  const margins = pageConfig.margins || {};

  const handleMarginChange = (side) => (e) => {
    const value = e.target.value === "" ? "" : Number(e.target.value);
    onChange({
      ...pageConfig,
      margins: { ...margins, [side]: value },
    });
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <div className={classes.drawerContent}>
        <Typography variant="h6">
          {i18n.t("documentTemplates.buttons.pageConfig")}
        </Typography>

        <TextField
          select
          fullWidth
          margin="dense"
          variant="outlined"
          label={i18n.t("documentTemplates.editor.paperSize")}
          value={pageConfig.paperSize || "A4"}
          onChange={(e) =>
            onChange({ ...pageConfig, paperSize: e.target.value })
          }
          className={classes.section}
        >
          {PAPER_SIZES.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          fullWidth
          margin="dense"
          variant="outlined"
          label={i18n.t("documentTemplates.editor.fontFamily")}
          value={pageConfig.fontFamily || "Times New Roman"}
          onChange={(e) =>
            onChange({ ...pageConfig, fontFamily: e.target.value })
          }
        >
          {FONT_OPTIONS.map((font) => (
            <MenuItem key={font} value={font}>
              {font}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          fullWidth
          margin="dense"
          variant="outlined"
          label={`${i18n.t("documentTemplates.editor.fontSize")} (pt)`}
          value={pageConfig.fontSize || 12}
          onChange={(e) =>
            onChange({ ...pageConfig, fontSize: Number(e.target.value) })
          }
        >
          {FONT_SIZES.map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </TextField>

        <Typography variant="subtitle2" className={classes.section}>
          {i18n.t("documentTemplates.editor.margins")}
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              margin="dense"
              variant="outlined"
              type="number"
              inputProps={{ min: 0, max: 8, step: 0.5 }}
              label={i18n.t("documentTemplates.editor.marginTop")}
              value={margins.top ?? 2.5}
              onChange={handleMarginChange("top")}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              margin="dense"
              variant="outlined"
              type="number"
              inputProps={{ min: 0, max: 8, step: 0.5 }}
              label={i18n.t("documentTemplates.editor.marginBottom")}
              value={margins.bottom ?? 2.5}
              onChange={handleMarginChange("bottom")}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              margin="dense"
              variant="outlined"
              type="number"
              inputProps={{ min: 0, max: 8, step: 0.5 }}
              label={i18n.t("documentTemplates.editor.marginLeft")}
              value={margins.left ?? 3}
              onChange={handleMarginChange("left")}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              margin="dense"
              variant="outlined"
              type="number"
              inputProps={{ min: 0, max: 8, step: 0.5 }}
              label={i18n.t("documentTemplates.editor.marginRight")}
              value={margins.right ?? 2}
              onChange={handleMarginChange("right")}
            />
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

export default PageConfigPanel;
